import { useProposalState } from '@src/shared/hooks';
import React, { useCallback, useEffect, useState } from 'react';

type CheckBoxProps = {
  onChange: (value: boolean) => void;
  className: string;
  value: boolean;
};

export const CheckBox: React.FC<CheckBoxProps> = ({
  onChange,
  className,
  value: externalValue,
}) => {
  const [value, setValue] = useState(false);
  const { loading } = useProposalState();

  useEffect(() => {
    setValue(externalValue);
  }, [externalValue]);

  const onClick = useCallback(() => {
    if (loading) return;
    onChange(!value);
    setValue((old) => !old);
  }, [loading, onChange, value]);

  const trueOrFale = value ? '/check-true.svg' : '/check-false.svg';
  return (
    <img
      onClick={onClick}
      src={trueOrFale}
      className={`${className} cursor-pointer ease-in-out`}
    />
  );
};
